import { atom } from 'jotai';

export const isNlsLoadingAtom = atom(false);
